function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-32 -14.967)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(32 14.967)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_24065",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 24065",
  d: "M53.6,22.43l-14.843-7.4a.591.591,0,0,0-.793.265L34.8,21.644a.591.591,0,0,0,.265.793l4.432,2.21-.393.789a.591.591,0,0,0,.265.793l.14.07-.764,1.36h-4.5A2.518,2.518,0,0,0,32,26.294v5.037a2.518,2.518,0,0,0,2.209-1.308h5.224a1.183,1.183,0,0,0,1.031-.6l1.159-2.065.2.1a.591.591,0,0,0,.793-.265l.393-.789,3.311,1.651a.591.591,0,0,0,.6-.039l.914-.618,1.632.814a.591.591,0,0,0,.793-.265l1.671-3.35,1.732-1.14A.591.591,0,0,0,53.6,22.43Z",
  transform: "translate(-32 -14.967)",
  fill: "#324655"
})));

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "camera",
    className: "fill",
    width: 21.925,
    height: 16.365,
    viewBox: "0 0 21.925 16.365",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera.19915f62.svg";
export { ForwardRef as ReactComponent };